/* Presentation adapter only: EcomSend owns validation, consent and subscriptions. */
(function () {
  'use strict';
  var configNode = document.querySelector('[data-sm-restock-config]');
  if (!configNode || configNode.dataset.ready) return;
  configNode.dataset.ready = 'true';
  var config = JSON.parse(configNode.textContent);
  var form = document.getElementById('sp4hForm-' + config.sectionId);
  var root = form && form.closest('.sp4h');
  var panel = root && root.querySelector('[data-sm-restock]');
  if (!panel) return;
  var button = panel.querySelector('[data-sm-restock-open]');
  var feedback = panel.querySelector('[data-sm-restock-feedback]');
  var nativeSelect = form.querySelector('select[name="id"]');
  var price = document.getElementById('sp4hPrice-' + config.sectionId);
  var bar = document.getElementById('sp4hSticky');
  var barButton = document.getElementById('sp4hStickyBtn');
  var barLabel = document.getElementById('sp4hStickyBtnText');
  var barVariant = document.getElementById('sp4hStickyVariant');
  var anchor = document.createComment('Original product form position');
  form.before(anchor);
  var selected = null, soldOut = false, lastOpener = null, waiting = null;
  var frame = null, frameObserver = null, lastModalOpen = false, queued = false;
  var quickButton = document.querySelector('.bmp-quickadd__btn');
  var quickNotify = null;
  if (quickButton) {
    quickNotify = button.cloneNode(true);
    quickNotify.hidden = true;
    quickButton.after(quickNotify);
  }
  if (barButton) barButton.prepend(button.querySelector('svg').cloneNode(true));
  document.body.classList.add('sm-restock-page');

  // EcomSend's public customization hook. Blank names are supported by the
  // app (subscriber_name defaults to "customer"); never fabricate user data.
  var previousAfterExecute = window.bisAfterExecute;
  window.bisAfterExecute = function (settings, options) {
    if (typeof previousAfterExecute === 'function') previousAfterExecute.apply(this, arguments);
    if (options) options.isNameRequired = false;
    scheduleEnhance();
  };
  function text(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  function label(variant) {
    return !variant || variant.title === 'Default Title' ? '' : variant.title.replace(/\bPurple\b/g, 'Morado');
  }
  function notify(message) {
    text(feedback, message);
    feedback.hidden = !message;
  }
  function updateDock() {
    if (!bar) return;
    var rect = button.getBoundingClientRect();
    var visible = rect.top >= 68 && rect.bottom <= innerHeight - 8;
    var docked = soldOut && !visible && !lastModalOpen;
    bar.toggleAttribute('data-restock-docked', docked);
    bar.toggleAttribute('inert', soldOut && !docked);
    if (soldOut) bar.setAttribute('aria-hidden', String(!docked));
    else bar.removeAttribute('aria-hidden');
    document.body.classList.toggle('sm-restock-dock-visible', docked);
  }
  function update(variant) {
    selected = variant;
    soldOut = !!variant && !variant.available;
    panel.hidden = !soldOut;
    root.classList.toggle('sm-restock-active', soldOut);
    document.body.classList.toggle('sm-restock-soldout', soldOut);
    if (soldOut && price && price.nextElementSibling !== form) price.after(form);
    if (!soldOut && anchor.nextSibling !== form) anchor.after(form);
    text(panel.querySelector('[data-sm-restock-color]'), label(variant) ? ' en ' + label(variant) : '');
    button.setAttribute('aria-label', 'Avísame cuando vuelva — ' + config.title + (label(variant) ? ' — ' + label(variant) : ''));
    if (quickNotify) quickNotify.hidden = !soldOut;
    if (bar && barButton) {
      bar.classList.toggle('sm-restock-sticky', soldOut);
      if (soldOut) {
        barButton.classList.remove('sp4h-sticky__btn--disabled');
        barButton.removeAttribute('aria-disabled');
        barButton.disabled = false;
        barButton.setAttribute('aria-label', button.getAttribute('aria-label'));
        text(barLabel, 'Avísame');
      } else {
        barButton.removeAttribute('aria-label');
      }
      text(barVariant, (soldOut ? 'Sin stock' : '') + (label(variant) ? (soldOut ? ' · ' : '') + label(variant) : ''));
    }
    notify('');
    updateDock();
  }
  function keyboardButton(element, accessibleName) {
    if (!element) return;
    element.setAttribute('role', 'button');
    element.setAttribute('tabindex', '0');
    element.setAttribute('aria-label', accessibleName);
    if (!element.dataset.smKeyboard) {
      element.dataset.smKeyboard = 'true';
      element.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); element.click(); }
      });
    }
  }
  function fieldLabel(input, caption, id) {
    if (!input || input.previousElementSibling && input.previousElementSibling.classList.contains('sm-restock-field-label')) return;
    input.id = input.id || id;
    var el = document.createElement('label');
    el.className = 'sm-restock-field-label';
    el.htmlFor = input.id;
    el.textContent = caption;
    input.before(el);
  }
  function syncModal() {
    if (!frame) return;
    var isOpen = getComputedStyle(frame).display !== 'none';
    document.body.classList.toggle('sm-restock-modal-open', isOpen);
    var returnFocus = !isOpen && lastModalOpen && lastOpener && lastOpener.isConnected;
    lastModalOpen = isOpen;
    updateDock();
    if (returnFocus) lastOpener.focus({preventScroll:true});
  }
  function enhance() {
    if (root.querySelector('.email-me-inlineButton')) root.classList.add('sm-restock-ready');
    var found = document.getElementById('email-me-frame');
    if (!found) return;
    if (frame !== found) {
      if (frameObserver) frameObserver.disconnect();
      frame = found;
      frameObserver = new MutationObserver(syncModal);
      frameObserver.observe(frame, {attributes:true,attributeFilter:['style','class']});
    }
    var content = frame.querySelector('.email-frame-content');
    var title = frame.querySelector('.frame-title');
    text(title, 'Te avisamos cuando vuelva');
    if (title) title.id = 'sm-restock-modal-title';
    if (content) {
      content.setAttribute('role', 'dialog');
      content.setAttribute('aria-modal', 'true');
      content.setAttribute('aria-labelledby', 'sm-restock-modal-title');
    }
    var email = frame.querySelector('.buyer-email');
    if (email) {
      email.type = 'email'; email.autocomplete = 'email'; email.inputMode = 'email';
      email.placeholder = 'tu@correo.com';
      email.setAttribute('aria-label', 'Tu correo electrónico');
      fieldLabel(email, 'Tu correo electrónico', 'sm-restock-email');
    }
    var name = frame.querySelector('.buyer-name');
    if (name) { name.required = false; name.tabIndex = -1; name.parentElement.classList.add('sm-restock-name-field'); }
    var variants = frame.querySelector('.selected-unavailable-variant');
    if (variants) {
      variants.setAttribute('aria-label', 'Color o versión');
      Array.from(variants.options).forEach(function (option) { text(option, option.textContent.replace(/\bPurple\b/g, 'Morado')); });
    }
    var submit = frame.querySelector('.email-me-submitButton');
    text(submit, 'Avísame cuando vuelva');
    keyboardButton(submit, 'Avísame cuando vuelva');
    keyboardButton(frame.querySelector('.close-box'), 'Cerrar aviso de stock');
    if (!frame.dataset.smKeys) {
      frame.dataset.smKeys = 'true';
      frame.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { event.preventDefault(); frame.querySelector('.close-box').click(); }
        if (event.key === 'Enter' && event.target.matches('.buyer-email')) { event.preventDefault(); frame.querySelector('.email-me-submitButton').click(); }
        if (event.key === 'Tab') {
          var focusable = Array.from(frame.querySelectorAll('input,select,[tabindex="0"]')).filter(function (el) { return !el.disabled && el.getClientRects().length; });
          var first = focusable[0], last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
    }
    syncModal();
  }
  function scheduleEnhance() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; enhance(); });
  }
  function open(opener) {
    if (!soldOut || waiting) return;
    lastOpener = opener;
    var targetId = String(selected.id), attempts = 0;
    function attempt() {
      waiting = null;
      if (!soldOut || String(selected.id) !== targetId) return;
      var trigger = root.querySelector('.email-me-inlineButton');
      if (!trigger || !document.getElementById('email-me-frame')) {
        if (++attempts < 50) { notify('Cargando el aviso…'); waiting = setTimeout(attempt, 200); }
        else notify('No pudimos abrir el aviso. Inténtalo de nuevo en un momento.');
        return;
      }
      // Use the existing app click handler, never its private API or a second list.
      trigger.click();
      enhance();
      var select = frame.querySelector('.selected-unavailable-variant');
      if (select && Array.from(select.options).some(function (option) { return option.value === targetId; })) {
        select.value = targetId;
        select.dispatchEvent(new Event('change', {bubbles:true}));
      }
      notify('');
      var focusTarget = frame.querySelector(innerWidth >= 768 ? '.buyer-email' : '.close-box');
      if (focusTarget) focusTarget.focus({preventScroll:true});
    }
    attempt();
  }
  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-sm-restock-open]');
    if (!target) return;
    event.preventDefault(); open(target);
  });
  if (barButton) barButton.addEventListener('click', function (event) {
    if (!soldOut) return;
    event.preventDefault(); event.stopImmediatePropagation(); open(barButton);
  }, true);
  document.addEventListener('soymomo:variant-change', function (event) {
    if (event.detail.sectionId === config.sectionId) update(event.detail.variant);
  });
  if ('IntersectionObserver' in window) new IntersectionObserver(updateDock, {threshold:[0,1],rootMargin:'-68px 0px -8px 0px'}).observe(button);
  window.addEventListener('resize', updateDock, {passive:true});
  // EcomSend injects/rebuilds its trigger and popup asynchronously. Only child
  // changes are observed, and all our DOM patches are idempotent.
  new MutationObserver(scheduleEnhance).observe(document.body, {childList:true,subtree:true});
  update(config.variants.find(function (variant) { return String(variant.id) === nativeSelect.value; }) || null);
  enhance();
})();
